import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useParams, Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import swal from "sweetalert";
import ListItemIcon from '@mui/material/ListItemIcon';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import SwipeLeftIcon from '@mui/icons-material/SwipeLeft';
import PieChart from '../Conference/Charts/PieChart';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useDeadline } from '../../../contexts/DeadlineContext';
const approve = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '6px', transform: 'scale(2)', pl: 5 }}>
    <FactCheckIcon />
  </Box>
);
const pending = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '6px', transform: 'scale(2)', pl: 5 }}
  >
    <SwipeLeftIcon />
  </Box>
);
const reject = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '6px', transform: 'scale(2)', pl: 5 }}
  >
    <SwipeLeftIcon />
  </Box>
);
const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}))


function createData(
  ids,
  name,
  calories,
  fat,
  carbs,
  protein,

) {
  return { ids, name, calories, fat, carbs, protein };
}
const rows = [
  createData(1, 'Frozen yoghurt', "Frozen@test.com", 123456,),
]



const ConferenceDashbord = () => {
  const [abstractArticle, setAbstractArticle] = React.useState([]);
  const [paidCollection, setAllPaidCollection] = React.useState([]);
  const [totalParticipantCount, setTotalParticipantCount] = React.useState([]);
  const [totalMaleParticipantCount, setTotalMaleParticipantCount] = React.useState([]);
  const [totalFemaleParticipantCount, setTotalFemaleParticipantCount] = React.useState([]);
  const [onlineUsers, setOnlineUsers] = useState([]);


  const eventid = localStorage.getItem('eventid');
  const role = localStorage.getItem('role');
  const eventName = localStorage.getItem('eventname');
  const isSmallScreen = useMediaQuery('(max-width:600px)');

  const { abstractHomeSetup } = useDeadline();
  const gradientBackground = '#05597D';
  const history = useHistory();
  useEffect(() => {
    axios.get(`api/get-conference-participnat-count?id=${eventid}`).then(res => {
      if (res.status === 200) {

        const totalParticipants = res.data.totalNormalParticipants;
        const maleParticipants = res.data.maleNormalParticipants;
        const femaleParticipants = res.data.femaleNormalParticipants;

        // Keeping the existing state names
        setTotalParticipantCount(totalParticipants);
        setTotalMaleParticipantCount(maleParticipants);
        setTotalFemaleParticipantCount(femaleParticipants);

      } else {
        swal('Error', "Check API Something Wrong", 'error');
      }
    });
  }, [eventid]);


  const handleGetOnlineUsers = () => {
    axios.get('/api/conference-online-users', {
      params: { event_id: eventid }  // pass event_id here
    })
      .then(res => {
        if (res.data.status === 200) {
          setOnlineUsers(res.data.online_users || []);
          swal('Success', `Fetched ${res.data.count || 0} online users`, 'success');
        } else {
          swal('Error', 'Failed to fetch online users', 'error');
        }
      })
      .catch(err => {
        console.error(err);
        swal('Error', 'Unable to fetch online users', 'error');
      });
  };



  return (
    <>
      <Box sx={{ padding: isSmallScreen ? 2 : 4, width: '100%' }} >
        <Grid container spacing={isSmallScreen ? 2 : 4}>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ color: "purple", marginTop: isSmallScreen ? "20%" : "3%" }}>
            <Button sx={{
              float: 'right',
              marginTop: '0%',
              background: abstractHomeSetup.color_code_two || gradientBackground,
              ":hover": {
                color: "white"
              }
            }}
              color='success'
              size='small'
              variant='contained'

              onClick={() => history.goBack()} >
              Back
            </Button>
            <Item>
              <Typography variant={isSmallScreen ? "h5" : "h4"} gutterBottom>
                Conference Management Dashboard
              </Typography>

            </Item>
          </Grid>

          <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
            <Item>
              <Grid container spacing={2}>

                <Grid item xs={12} sm={12} md={12} lg={4}>
                  <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                      <Typography variant="h5" component="div">
                        Total Participant
                      </Typography>
                      <Typography variant="body2" variant="h2" color="success.main" key={1}>
                        {pending}. {totalParticipantCount}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small" component={Link} to="#">
                        Learn More
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={4}>
                  <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                      <Typography variant="h5" component="div">
                        Total Male Participant
                      </Typography>
                      <Typography variant="body2" variant="h2" color="secondary" key={1}>
                        {pending}. {totalMaleParticipantCount}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small" component={Link} to="#">
                        Learn More
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={4}>
                  <Card sx={{ minWidth: 275 }}>
                    <CardContent>
                      <Typography variant="h5" component="div">
                        Total Female Participant
                      </Typography>
                      <Typography variant="body2" variant="h2" color="error.main" key={1}>
                        {pending}. {totalFemaleParticipantCount}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button size="small" component={Link} to="#">
                        Learn More
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              </Grid>
            </Item>
          </Grid>
        </Grid>

        {/* {PieChart} */}
        <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
          <Item>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={4}>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <PieChart
                      totalParticipantCount={totalParticipantCount}
                      totalMaleParticipantCount={totalMaleParticipantCount}
                      totalFemaleParticipantCount={totalFemaleParticipantCount}
                    />
                  </CardContent>
                  <CardActions>
                    <Button size="small" component={Link} to="#">
                      Learn More
                    </Button>
                  </CardActions>
                </Card>
              </Grid>





            </Grid>
          </Item>
        </Grid>


        <Grid item xs={12} style={{ color: "purple", marginTop: "2%" }}>
          <Item>
            <Grid item xs={12} style={{ marginBottom: '20px' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleGetOnlineUsers}
              >
                Get Online Users
              </Button>
            </Grid>
            <Typography variant={isSmallScreen ? "h6" : "h5"} gutterBottom>
              Online Users ({onlineUsers.length})
            </Typography>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>

                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Login Time</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {onlineUsers.map((user, index) => (
                    <TableRow
                      key={user.id}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {index + 1}
                      </TableCell>
                      <TableCell>{user.name}</TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell>{new Date(user.login_time).toLocaleString()}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Item>
        </Grid>





        <hr></hr>
      </Box>
    </>
  );
}

export default ConferenceDashbord;
